import { ComponentType, useEffect } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { AsyncThunk } from "@reduxjs/toolkit";

import { getTokenInfo } from "../../api/actions";

interface OauthTokenValidatorProps extends RouteComponentProps {
  token: string | null;
  logOutAction: AsyncThunk<void, void, any>;
  redirectUrl?: string;
  dispatch: (obj: object) => Promise<void>;
}

const OauthTokenValidator = ({
  token,
  logOutAction,
  redirectUrl,
  dispatch,
  history
}: OauthTokenValidatorProps): void => {
  useEffect(() => {
    if (token) {
      getTokenInfo(token).then(response => {
        const { status } = response;

        if (status === 401) {
          dispatch(logOutAction()).then(() => redirectUrl && history.push(redirectUrl));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
};

interface State {
  user: {
    token: string;
  };
}

export default withRouter(
  connect(
    (state: State) => ({ token: state.user.token }),
    dispatch => ({
      dispatch
    })
    //@ts-ignore TODO: possibly refactor to use hooks
  )(OauthTokenValidator as ComponentType<OauthTokenValidatorProps>)
);
